/**
 * @file 博士会成员tab切换页面
 * @author  rentao(v-rentao@baidu.com)
 */
import React, { useMemo } from 'react';
import { Carousel, Row } from 'antd';

import './style.less'
import NumberTab from './numbertab'

import { MumberTabItem } from './types'

interface Iprops {
    className?: string;
    list?: MumberTabItem[][];
}
const NumberTabGroup: React.FC<Iprops> = React.memo((props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);

    return (
        <div>
            <Carousel autoplay={false}>
                {list.map((sublist, index) => {
                    return (
                        <div className="all" key={`${index}`}>
                            <div className="carousel-body">
                                <Row>
                                    {sublist.map(item => (
                                        <NumberTab
                                            key={`${item.name},${item.text}`}
                                            {...item}
                                        />
                                    ))}
                                </Row>
                            </div>
                        </div>);
                })}
            </Carousel>

        </div>
    )

});

export default NumberTabGroup
